import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    QueryList,
    SimpleChanges,
    Type,
    ViewChildren
} from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {ViewAnchorDirective} from "../../directives/view-anchor.directive";
import {AttachmentHandlerView, RefreshEventModel} from "./attachment-handler.model";
import {NotificationService} from "../../services/common/notification.service";
import {Constants} from "../../utils/constants";

@Component({
    selector: 'app-attachment-handler',
    templateUrl: './attachment-handler.component.html',
    styleUrls: ['./attachment-handler.component.scss']
})
export class AttachmentHandlerComponent implements OnInit, OnChanges, AfterViewInit {

    @Input() optionalElements: any[];
    @Input() chosenElements: any[];
    @Input() optionalViewComponent: Type<any>;
    @Input() chosenViewComponent: Type<any>;
    @Input() optionalTitle: string;
    @Input() chosenTitle: string;
    @Input() acceptString: string;
    @Input() isMultiple: boolean = true;
    @Input() maxElement: number = -1;

    @Output() refreshEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() attachmentSaveEvent: EventEmitter<any> = new EventEmitter<any>();

    @ViewChildren(ViewAnchorDirective) viewAnchor: QueryList<ViewAnchorDirective>;

    filteredOptionalElements: any[];
    filterValue: string;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private cd: ChangeDetectorRef, private notificationService: NotificationService) {
    }

    ngOnInit(): void {
        this.filteredOptionalElements = this.optionalElements;
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
    }


    ngOnChanges(changes: SimpleChanges): void {
        if(this.optionalViewComponent) {
                setTimeout(() => {
                    this.loadComponent()
                }, 1000);
        }
    }

    loadComponent() {
        const optionalComponentFactory = this.componentFactoryResolver.resolveComponentFactory(this.optionalViewComponent);
        const chosenComponentFactory = this.componentFactoryResolver.resolveComponentFactory(this.chosenViewComponent);
        this.viewAnchor.forEach(ad => {
            const viewContainerRef = ad.viewContainerRef;
            viewContainerRef.clear();
            let componentRef;
            if (ad.isOptional) {
                componentRef = viewContainerRef.createComponent<AttachmentHandlerView>(optionalComponentFactory);
            } else {
                componentRef = viewContainerRef.createComponent<AttachmentHandlerView>(chosenComponentFactory);
            }

            componentRef.instance.data = ad.data;
            componentRef.instance.isOptional = ad.isOptional;
            componentRef.instance.refreshEvent = ad.refreshEvent;
        })

    }

    drop(event: CdkDragDrop<any[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            // if(this.maxElement > -1 && this.chosenElements.length == this.maxElement){
            //     this.notificationService.showWarning("error.attachment.listLengthIsMax")
            // }else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
            // }
        }
        this.refresh();
    }

    public saveCallback(resp) {
        this.attachmentSaveEvent.emit(resp);

        this.refresh();
    }

    public refreshFromChild($event: RefreshEventModel) {
        /** Csere esemény érkezett -> adatcsere végrehajtása, majd szülő komponens értesítése a módosulásról */
        if ($event && $event.type == Constants.ATTACHMENT_REFRESH_EVENT_TYPES.CHANGE_DATA) {
            let arrayToSearch: any[];
            if ($event.isOptional) {
                arrayToSearch = this.optionalElements;
            } else {
                arrayToSearch = this.chosenElements;
            }
            let currentIndex = arrayToSearch.findIndex(element => {
                return element.id == $event.oldId;
            });

            if (currentIndex >= 0) {
                arrayToSearch[currentIndex] = $event.newData;
            }
        }

        this.refresh()
    }

    private refresh() {

        setTimeout(() => {
            this.loadComponent()
        }, 200);
        this.refreshEvent.emit();
    }

    filter() {
        this.filteredOptionalElements = this.optionalElements.filter(attachment => {
            var search = attachment.name.search(this.filterValue);
            return search > -1;
        });
        this.refresh();
    }
}
